import {gql} from "@apollo/client/core";
import {ProductDescriptionFragment} from "./product-description-fragment";
import {ProductImageFragment} from "./product-image-fragment";
import {ProductPriceFragment} from "./product-price-fragment";
import {CartProductFullFragment} from "./cart-product-full-fragment";

export const CartProductGroupFragment = gql`
    fragment CartProductGroupFragment on CartProductGroup {
        id
        retailPriceMin {
            ...ProductPriceFragment
        }
        retailPriceMax {
            ...ProductPriceFragment
        }
        priceMin {
            ...ProductPriceFragment
        }
        priceMax {
            ...ProductPriceFragment
        }
        vatTaxRate
        productDescription {
            ...ProductDescriptionFragment
        }
        volumeMin
        volumeMax
        catalogImages {
            ...ProductImageFragment
        }
        products {
            ...CartProductFullFragment
        }
        featured
        seoCrossMarketUrl
    }

    ${ProductDescriptionFragment}
    ${ProductImageFragment}
    ${ProductPriceFragment}
    ${CartProductFullFragment}
`;
